<template>
    <!-- <div v-if="serialModel.showTimer">
        <p id="serial_timer">
            <span>{{lbl.serial.expire_in}}</span>
            <span id="serial_timeleft"
                :class="{'serial-expired': timer.isExpired}">
                {{timer.displayTime}}
            </span>
        </p>
    </div> -->
    <div v-if="serialModel.showTimer" class="d-none">
        <p id="serial_timer">
            <span class="text-time">รหัสจะหมดอายุภายใน </span>
            <span class="number-time"
                :class="{'serial-expired': timer.isExpired}">
                {{timer.displayTime}}
            </span>
        </p>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
export default {
    name: 'SerialTimer',
    props: {
        lbl: Object,
        serialModel: Object,

        controller: Object
    },
    data: function () {
        return {
            timer: new TimerHelper()
        };
    },
    created: function () {
        this.initial();
    },
    methods: {
        initial: function () {
            if(this.timer.interval)
                this.timer.stopTimer();

            this.timer.initialTimer(this.serialModel.expireIn);
            if (this.serialModel.showTimer)
                this.timer.runTimer(this.serialExpired);
            console.log(this.timer)
        },
        serialExpired: function () {
            this.controller.sendSerialExpire();
        },
        isShowTimer: function() {

        },
    }
}
</script>
<style lang="scss" scoped>
#serial_timer {
    width: 100%;
    margin: {
        top: 3px;
        bottom: 3px;
    };
    //font
    font-size: 2rem;
    text-align: center;
    line-height: 0.9;

    #serial_timeleft {
        color: black;

        &.serial-expired {
            color: red;
        }
    }
    .text-time {
        font-size: 16px; 
        color: #333333; 
        font-family: 'KanitRegular';
    }
    .number-time {
        font-size: 16px; 
        color: #e30613; 
        font-family: 'KanitRegular';
    }
}
</style>
